
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`Le laboratoire Novavax, qui produit ce vaccin officiellement nommé NVX-CoV2373,
est basé au Maryland (USA). Fondé en 1987, il est spécialisé dans les maladies
infectieuses mais n’avait pas encore livré de vaccin sur le marché.`}</p>
    <p>{`En septembre 2020, Novavax a signé un accord avec le Serum Institute of India,
afin d'augmenter sa capacité de production à deux millions de doses par année.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;